import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F() {};
      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
import React from 'react';
import PropTypes from 'prop-types';
import Geocode from 'react-geocode';
import { ChildrenPropType } from '../../services/proptypes';
import { calculateDistance } from '../../utils/geo';
export var LOCATION_STATUS = {
  IDLE: 0,
  WAITING_FOR_USER_LOCATION: 1,
  CALCULATING_DIST: 2,
  FINISHED: 3,
  LOCATION_UNAVAILABLE: 4
};
var GeoClosestLocation = /*#__PURE__*/function (_React$Component) {
  _inherits(GeoClosestLocation, _React$Component);
  var _super = _createSuper(GeoClosestLocation);
  function GeoClosestLocation(props) {
    var _this;
    _classCallCheck(this, GeoClosestLocation);
    _this = _super.call(this, props);
    Geocode.setApiKey(process.env.GOOGLE_MAPS_API_KEY);
    if (process.env.NODE_ENV === 'development') {
      Geocode.enableDebug();
    }
    _this.state = {
      loading: false,
      locationStatus: LOCATION_STATUS.IDLE,
      locationsWithDistance: props.locations.map(function (l) {
        return _objectSpread(_objectSpread({}, l), {}, {
          fullAddress: GeoClosestLocation.getFullAddress(l)
        });
      })
    };
    _this.hasUsersLocation = _this.hasUsersLocation.bind(_assertThisInitialized(_this));
    _this.doesNotHaveUsersLocation = _this.doesNotHaveUsersLocation.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(GeoClosestLocation, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var start = this.props.start;
      if (start) {
        this.getUsersLocation();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var oldStart = prevProps.start;
      var newStart = this.props.start;
      var locationStatus = this.state.locationStatus;
      if (newStart && !oldStart && locationStatus === LOCATION_STATUS.IDLE) {
        this.getUsersLocation();
      }
    }
  }, {
    key: "getUsersLocation",
    value: function getUsersLocation() {
      if ('geolocation' in navigator) {
        this.setState({
          loading: true,
          locationStatus: LOCATION_STATUS.WAITING_FOR_USER_LOCATION
        });
        navigator.geolocation.getCurrentPosition(this.hasUsersLocation, this.doesNotHaveUsersLocation);
      } else {
        this.setState({
          loading: false,
          locationStatus: LOCATION_STATUS.LOCATION_UNAVAILABLE
        });
      }
    }
  }, {
    key: "doesNotHaveUsersLocation",
    value: function doesNotHaveUsersLocation() {
      this.setState({
        loading: false,
        locationStatus: LOCATION_STATUS.LOCATION_UNAVAILABLE
      });
    }
  }, {
    key: "hasUsersLocation",
    value: function () {
      var _hasUsersLocation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(position) {
        var _this$props, locations, distanceUnit, userLat, userLong, locationsWithDistance, _iterator, _step, location, fullAddress, distance, results, _results$results$0$ge, lat, lng;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this$props = this.props, locations = _this$props.locations, distanceUnit = _this$props.distanceUnit;
              this.setState({
                loading: true,
                locationStatus: LOCATION_STATUS.CALCULATING_DIST
              });
              userLat = position.coords.latitude;
              userLong = position.coords.longitude;
              locationsWithDistance = []; // eslint-disable-next-line no-restricted-syntax
              _iterator = _createForOfIteratorHelper(locations);
              _context.prev = 6;
              _iterator.s();
            case 8:
              if ((_step = _iterator.n()).done) {
                _context.next = 24;
                break;
              }
              location = _step.value;
              fullAddress = GeoClosestLocation.getFullAddress(location);
              distance = -1;
              _context.prev = 12;
              _context.next = 15;
              return Geocode.fromAddress(fullAddress);
            case 15:
              results = _context.sent;
              if (results) {
                _results$results$0$ge = results.results[0].geometry.location, lat = _results$results$0$ge.lat, lng = _results$results$0$ge.lng;
                distance = calculateDistance(lat, lng, userLat, userLong, distanceUnit);
              }
              _context.next = 21;
              break;
            case 19:
              _context.prev = 19;
              _context.t0 = _context["catch"](12);
            case 21:
              locationsWithDistance.push(_objectSpread(_objectSpread({}, location), {}, {
                fullAddress: fullAddress,
                distance: distance,
                distanceUnit: distanceUnit
              }));
            case 22:
              _context.next = 8;
              break;
            case 24:
              _context.next = 29;
              break;
            case 26:
              _context.prev = 26;
              _context.t1 = _context["catch"](6);
              _iterator.e(_context.t1);
            case 29:
              _context.prev = 29;
              _iterator.f();
              return _context.finish(29);
            case 32:
              locationsWithDistance.sort(function (a, b) {
                if (a.distance === -1) return 1;
                if (b.distance === -1) return -1;
                return a.distance > b.distance ? 1 : -1;
              });
              this.setState({
                loading: false,
                locationStatus: LOCATION_STATUS.FINISHED,
                locationsWithDistance: locationsWithDistance
              });
            case 34:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[6, 26, 29, 32], [12, 19]]);
      }));
      function hasUsersLocation(_x) {
        return _hasUsersLocation.apply(this, arguments);
      }
      return hasUsersLocation;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        loading = _this$state.loading,
        locationStatus = _this$state.locationStatus,
        locationsWithDistance = _this$state.locationsWithDistance;
      var children = this.props.children;
      return children({
        state: locationStatus,
        locations: locationsWithDistance,
        loading: loading
      });
    }
  }], [{
    key: "getFullAddress",
    value: function getFullAddress(location) {
      return "".concat(location.street, ", ").concat(location.city, ", ").concat(location.state, " ").concat(location.zip);
    }
  }]);
  return GeoClosestLocation;
}(React.Component);
export { GeoClosestLocation as default };
GeoClosestLocation.propTypes = {
  start: PropTypes.bool,
  distanceUnit: PropTypes.oneOf(['M', 'K']),
  locations: PropTypes.arrayOf(PropTypes.shape({
    city: PropTypes.string,
    state: PropTypes.string,
    street: PropTypes.string,
    zip: PropTypes.string
  })),
  children: ChildrenPropType.isRequired
};
GeoClosestLocation.defaultProps = {
  start: false,
  distanceUnit: 'M',
  locations: []
};